var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnEditBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9172 14.158V17.9174C17.9172 18.4159 17.7191 18.894 17.3666 19.2465C17.0141 19.599 16.536 19.7971 16.0375 19.7971H2.87969C2.38116 19.7971 1.90306 19.599 1.55055 19.2465C1.19804 18.894 1 18.4159 1 17.9174V4.75957C1 4.26105 1.19804 3.78294 1.55055 3.43043C1.90306 3.07792 2.38116 2.87988 2.87969 2.87988H6.63906",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9172 14.158V17.9174C17.9172 18.4159 17.7191 18.894 17.3666 19.2465C17.0141 19.599 16.536 19.7971 16.0375 19.7971H2.87969C2.38116 19.7971 1.90306 19.599 1.55055 19.2465C1.19804 18.894 1 18.4159 1 17.9174V4.75957C1 4.26105 1.19804 3.78294 1.55055 3.43043C1.90306 3.07792 2.38116 2.87988 2.87969 2.87988H6.63906",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9172 14.158V17.9174C17.9172 18.4159 17.7191 18.894 17.3666 19.2465C17.0141 19.599 16.536 19.7971 16.0375 19.7971H2.87969C2.38116 19.7971 1.90306 19.599 1.55055 19.2465C1.19804 18.894 1 18.4159 1 17.9174V4.75957C1 4.26105 1.19804 3.78294 1.55055 3.43043C1.90306 3.07792 2.38116 2.87988 2.87969 2.87988H6.63906",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9172 14.158V17.9174C17.9172 18.4159 17.7191 18.894 17.3666 19.2465C17.0141 19.599 16.536 19.7971 16.0375 19.7971H2.87969C2.38116 19.7971 1.90306 19.599 1.55055 19.2465C1.19804 18.894 1 18.4159 1 17.9174V4.75957C1 4.26105 1.19804 3.78294 1.55055 3.43043C1.90306 3.07792 2.38116 2.87988 2.87969 2.87988H6.63906",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.868 13.9698L19.7965 4.94734L15.8491 1L6.92063 9.92852L6.63867 14.1578L10.868 13.9698Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.868 13.9698L19.7965 4.94734L15.8491 1L6.92063 9.92852L6.63867 14.1578L10.868 13.9698Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.868 13.9698L19.7965 4.94734L15.8491 1L6.92063 9.92852L6.63867 14.1578L10.868 13.9698Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.868 13.9698L19.7965 4.94734L15.8491 1L6.92063 9.92852L6.63867 14.1578L10.868 13.9698Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEditBlack);
export default __webpack_public_path__ + "static/media/BtnEditBlack.5a8424a487ad0552eb641a365c8f8b44.svg";
export { ForwardRef as ReactComponent };